module.exports = __webpack_public_path__ + "static/media/10.e6299b29.jpg";